type ClerkErrorLike = {
  errors?: Array<{
    code?: string;
    longMessage?: string;
    message?: string;
    shortMessage?: string;
  }>;
  message?: string;
};

const ALREADY_SIGNED_IN_CODES = new Set([
  'already_signed_in',
  'identifier_already_signed_in',
  'session_exists',
]);

export const getClerkErrorMessage = (
  error: ClerkErrorLike | null | undefined,
  fallbackMessage: string
) =>
  error?.errors?.[0]?.longMessage ||
  error?.errors?.[0]?.shortMessage ||
  error?.errors?.[0]?.message ||
  error?.message ||
  fallbackMessage;

export const isAlreadySignedInClerkError = (
  error: ClerkErrorLike | null | undefined
) => {
  const code = error?.errors?.[0]?.code?.toLowerCase();
  if (code && ALREADY_SIGNED_IN_CODES.has(code)) return true;

  return /already signed in/i.test(getClerkErrorMessage(error, ''));
};
